import './modal.scss'
export default function modal() {
  'ngInject'
  var directive = {
    restrict: 'AE',
    templateUrl: 'app/components/modal/modal.html',
    scope: {
      buttonText: '@',
      className: '@',
      itemId: '@',
    },
    link: modalLink,
    transclude: true,
  }

  return directive

  function modalLink() {}
}
